var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "fixBottom", staticClass: "popup px-16 py-24 p-md-24 p-lg-56" },
    [
      _c("div", {
        staticClass: "close",
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      }),
      _vm._v(" "),
      _c("h2", { staticClass: "mb-32" }, [
        _vm._v(_vm._s(_vm.translations.save_popup.title))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-40" }, [
        _vm._v(_vm._s(_vm.translations.save_popup.description))
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "link-field d-flex justify-content-between align-items-center  mb-40"
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.privateUrl,
                expression: "privateUrl"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.privateUrl },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.privateUrl = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "copy ml-32" }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:copy",
                    value: _vm.privateUrl,
                    expression: "privateUrl",
                    arg: "copy"
                  },
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:success",
                    value: _vm.onCopy,
                    expression: "onCopy",
                    arg: "success"
                  }
                ]
              },
              [_vm._v(_vm._s(_vm.translations.save_popup.copy))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "tooltip tooltip-top",
                class: { visible: _vm.copied }
              },
              [_vm._v(_vm._s(_vm.translations.save_popup.copied))]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "mb-40" }),
      _vm._v(" "),
      _c("ValidationObserver", {
        ref: "observer",
        attrs: { tag: "div", slim: true },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              return [
                !_vm.success
                  ? [
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c("el-input", {
                            staticClass: "col-12 mb-24",
                            attrs: {
                              type: "email",
                              label: _vm.translations.save_popup.email,
                              rules: "required|email"
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("ValidationProvider", {
                        ref: "provider",
                        attrs: {
                          vid: "privacy_policy",
                          name: _vm.translations.save_popup.privacy_policy,
                          rules: "required",
                          bails: false
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var classes = ref.classes
                                var errors = ref.errors
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "privacy d-flex align-items-center",
                                      on: {
                                        click: function($event) {
                                          _vm.privacyPolicy = !_vm.privacyPolicy
                                        }
                                      }
                                    },
                                    [
                                      _c("el-checkbox", {
                                        attrs: { value: _vm.privacyPolicy }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        staticClass:
                                          "ml-12 mb-0 font-weight-light",
                                        attrs: {
                                          for:
                                            _vm.translations.save_popup
                                              .privacy_policy
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.privacyPolicyLinkText
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  errors[0]
                                    ? _c(
                                        "label",
                                        {
                                          staticClass: "text-status-error small"
                                        },
                                        [_vm._v(_vm._s(errors[0]))]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ]
                  : [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.translations.save_popup.save_mail_success)
                        )
                      ])
                    ],
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex mt-40 justify-content-between align-items-center"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-accent text-white",
                        attrs: {
                          type: "submit",
                          disabled:
                            invalid || !_vm.acceptedPrivacyPolicy || _vm.success
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.submit($event)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.translations.save_popup.send))]
                    ),
                    _vm._v(" "),
                    _vm.localSchedule.activities.length > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "export",
                            attrs: {
                              href: _vm.route("schedule-pdf", [
                                _vm.localSchedule.id
                              ])
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.translations.save_popup.export_pdf)
                            ),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.svg("export", "icon"))
                              }
                            })
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }